import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banner"
}
const _hoisted_2 = ["innerHTML"]

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { daysBetween, strToDate, dayAndMonth, slovenianDayMonth, slovenianDayOfWeek } from '@/utils/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ClosedBanner',
  props: {
    dateFrom: {},
    dateTo: {}
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()

const from = computed(() => strToDate(props.dateFrom))
const to = computed(() => strToDate(props.dateTo))

const showBanner = computed(() => {
    const until = daysBetween(new Date(), from.value)
    const count = daysBetween(from.value, to.value)

    const alreadyPassed = until + count <= 0
    const invalidDates = count <= 0
    const happening = until <= 0

    return !alreadyPassed && !invalidDates && happening
})

const untilDate = computed(() => {
    const until = daysBetween(new Date(), from.value)
    const count = daysBetween(from.value, to.value)

    const countLeft = until + count
    const word =
        countLeft === 1
            ? t('closedBanner.tomorrow')
            : countLeft === 2
              ? t('closedBanner.dayAfterTomorrow')
              : ''
    const dayName = countLeft < 7 && slovenianDayOfWeek(to.value)
    return word
        ? `${word} <small>(${dayAndMonth(to.value)})</small>`
        : dayName
          ? `${dayName} <small>(${dayAndMonth(to.value)})</small>`
          : slovenianDayMonth(to.value)
})

return (_ctx: any,_cache: any) => {
  return (showBanner.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('closedBanner.text')) + " ", 1),
          _createElementVNode("span", { innerHTML: untilDate.value }, null, 8, _hoisted_2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})